<script lang="ts">
	export let fill = "#bcbfc3";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 30 30">
	<g>
		<g>
			<path
				d="M72.195 154.636h-.932a11.631 11.631 0 0 0-1.574-3.8l.66-.654a2.5 2.5 0 0 0 0-3.522l-.115-.115a2.487 2.487 0 0 0-3.522 0l-.66.654a11.809 11.809 0 0 0-3.795-1.574v-.925a2.5 2.5 0 0 0-2.493-2.494h-.157a2.5 2.5 0 0 0-2.493 2.494v.926a11.9 11.9 0 0 0-3.8 1.574l-.654-.654a2.487 2.487 0 0 0-3.522 0l-.115.115a2.487 2.487 0 0 0 0 3.522l.654.654a11.9 11.9 0 0 0-1.574 3.8h-.926a2.492 2.492 0 0 0-2.493 2.487v.163a2.5 2.5 0 0 0 2.493 2.493h.923a11.866 11.866 0 0 0 1.574 3.795l-.654.654a2.491 2.491 0 0 0 0 3.528l.115.115a2.5 2.5 0 0 0 3.522 0l.654-.66a11.631 11.631 0 0 0 3.8 1.574v.926a2.5 2.5 0 0 0 2.493 2.493h.157a2.5 2.5 0 0 0 2.493-2.493v-.926a11.546 11.546 0 0 0 3.795-1.574l.66.66a2.5 2.5 0 0 0 3.522 0l.115-.115a2.506 2.506 0 0 0 0-3.528l-.66-.654a11.6 11.6 0 0 0 1.574-3.795h.932a2.492 2.492 0 0 0 2.487-2.493v-.163a2.487 2.487 0 0 0-2.484-2.488zm1.277 2.651a1.282 1.282 0 0 1-1.277 1.283h-1.429a.6.6 0 0 0-.593.5 10.5 10.5 0 0 1-1.755 4.236.614.614 0 0 0 .067.781l1 1a1.275 1.275 0 0 1 0 1.81l-.109.115a1.282 1.282 0 0 1-1.816 0l-1-1a.6.6 0 0 0-.775-.067 10.661 10.661 0 0 1-4.236 1.755.6.6 0 0 0-.5.593v1.422a1.284 1.284 0 0 1-1.283 1.283h-.157a1.284 1.284 0 0 1-1.283-1.283v-1.422a.6.6 0 0 0-.5-.593 10.625 10.625 0 0 1-4.236-1.755.557.557 0 0 0-.345-.109.585.585 0 0 0-.43.176l-1 1a1.282 1.282 0 0 1-1.816 0l-.115-.115a1.278 1.278 0 0 1 0-1.81l1.011-1a.614.614 0 0 0 .067-.781 10.5 10.5 0 0 1-1.755-4.236.6.6 0 0 0-.593-.5h-1.439a1.284 1.284 0 0 1-1.283-1.283v-.163a1.282 1.282 0 0 1 1.283-1.277H48.6a.6.6 0 0 0 .593-.5 10.538 10.538 0 0 1 1.755-4.236.605.605 0 0 0-.067-.775l-1.011-1a1.293 1.293 0 0 1 0-1.816l.115-.115a1.293 1.293 0 0 1 1.816 0l1 1.011a.605.605 0 0 0 .775.067 10.454 10.454 0 0 1 4.236-1.755.61.61 0 0 0 .5-.6V144.7a1.284 1.284 0 0 1 1.283-1.283h.157a1.284 1.284 0 0 1 1.283 1.283v1.422a.61.61 0 0 0 .5.6 10.489 10.489 0 0 1 4.236 1.755.607.607 0 0 0 .775-.067l1-1.011a1.293 1.293 0 0 1 1.816 0l.109.115a1.282 1.282 0 0 1 0 1.816l-1 1a.605.605 0 0 0-.067.775 10.538 10.538 0 0 1 1.755 4.236.6.6 0 0 0 .593.5h1.428a1.281 1.281 0 0 1 1.277 1.277z"
				transform="translate(-44.682 -142.205)"
				style={`fill:${fill}`} />
		</g>
		<g transform="translate(7.983 7.981)">
			<circle cx="7.02" cy="7.02" r="7.02" style={`fill:${fill}`} />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		path,
		circle {
			transition: fill 0.5s;
		}
	}

</style>
